function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent, registerEqualHeight } from '../../../../wdh-foundation/wdh';

/**
 * @module wdh-image-spot
 */
var WDHImageSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * Base WDHImageSpot component.
   * A component to show a number of images in a sequence with two accompanying textfields for each image.
   *
   * @param {string} [className="image-spot"] - The css class name that uniquely identifies the component.
   *
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHImageSpot() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image-spot';
    _classCallCheck(this, WDHImageSpot);
    _this = _callSuper(this, WDHImageSpot, [className]);

    // Public interface
    /**
     * Controls whether the WDHImageSpot should force all images to the same height
     * @type {boolean}
     * @default false
     */
    _this.useEqualImageHeight = false;
    /**
     * Controls whether the WDHImageSpot should force all header texts to be the same height
     * @type {boolean}
     * @default false
     */
    _this.useEqualHeaderHeight = false;
    /**
     * Controls whether the WDHImageSpot should force all body texts to be the same height
     * @type {boolean}
     * @default false
     */
    _this.useEqualBodyHeight = false;

    /**
     * Controls whether the entire WDHImageSpot should be clickable
     * @type {boolean}
     * @default false
     */
    _this.makeImageSpotClickable = false;
    return _this;
  }
  _inherits(WDHImageSpot, _WDHComponent);
  return _createClass(WDHImageSpot, [{
    key: "init",
    value: function init(component) {
      if (this.useEqualImageHeight) {
        registerEqualHeight(component.querySelectorAll('.image-spot-element-image'));
      }
      if (this.useEqualHeaderHeight) {
        registerEqualHeight(component.querySelectorAll('.image-spot-element-header'));
      }
      if (this.useEqualBodyHeight) {
        registerEqualHeight(component.querySelectorAll('.image-spot-element-text'));
      }
      if (this.makeImageSpotClickable) {
        this.makeClickable(component.querySelectorAll('.image-spot-element'));
      }
    }
  }, {
    key: "makeClickable",
    value: function makeClickable(spots) {
      spots.forEach(function (spot) {
        var link = spot.querySelector('.image-spot-element-link a');
        if (link !== null) {
          // only wrap the image-spot if a link exists.
          var href = link.getAttribute('href');
          var target = link.getAttribute('target');
          var wrapper = document.createElement('a');
          wrapper.setAttribute('href', href);
          wrapper.setAttribute('target', target);
          while (spot.childNodes.length > 0) {
            wrapper.appendChild(spot.childNodes[0]);
          }

          // IE doesn't support prepend.  old-fashioned way it is....
          spot.insertBefore(wrapper, spot.firstChild);
        }
      });
    }
  }]);
}(WDHComponent);
export default WDHImageSpot;